import { zlbApiExpenseImportsResultPost, zlbApiExpenseImportsSubmitPost } from '@/api/zlbExpense';
import { getVehicleTemplate, reqvehicleConfirm } from '../services';

export default {
  namespace: 'carManage',
  state: {},
  effects: {
    *commitUpload({ payload }, { call }) {
      const res = yield call(zlbApiExpenseImportsSubmitPost, payload);
      return res;
    },
    *pollingQueryRes({ payload }, { call }) {
      const res = yield call(zlbApiExpenseImportsResultPost, payload);
      return res;
    },
    *confirmImport({ payload }, { call }) {
      const res = yield call(reqvehicleConfirm, payload);
      return res;
    },
    *getVehicleTemplate({ payload }, { call }) {
      const result = yield call(getVehicleTemplate, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
